import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";
import { api } from "@/lib/api";

function Avatar({ url, name, size = 40 }) {
    const initial = (name || "?").charAt(0).toUpperCase();
    if (url) {
        return <img src={url.startsWith("http") ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`} alt="" className="rounded-full object-cover" style={{ width: size, height: size }} />;
    }
    return (
        <div className="rounded-full bg-[var(--ok-accent)] text-black font-display font-black flex items-center justify-center" style={{ width: size, height: size, fontSize: size * 0.4 }}>{initial}</div>
    );
}

export default function Leaderboard() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/social/leaderboard", { params: { limit: 50 } })
            .then((r) => setItems(r.data.items || []))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="ok-container py-10 max-w-4xl" data-testid="leaderboard-page">
            <div className="font-mono text-[10px] uppercase tracking-widest opacity-50 mb-3 flex items-center gap-2">
                <Trophy className="w-3 h-3" /> UNVEILED · Top Contributors
            </div>
            <h1 className="font-display text-4xl mb-2">Top Witnesses</h1>
            <p className="opacity-70 text-sm mb-8">Reputation is earned through upvotes on your comments. The deeper your analysis, the higher you climb.</p>

            {loading ? (
                <div className="font-mono text-xs opacity-50">Loading…</div>
            ) : items.length === 0 ? (
                <div className="ok-card p-6 text-center text-sm opacity-70">No contributors yet. Be the first.</div>
            ) : (
                <div className="space-y-2">
                    {items.map((u, i) => (
                        <Link key={u.id} to={`/u/${u.id}`} className="ok-card p-4 flex items-center gap-4 hover:border-[var(--ok-accent)] transition" data-testid={`leaderboard-row-${u.id}`}>
                            <div className={`font-display text-2xl w-10 text-center ${i < 3 ? "text-[var(--ok-accent)]" : "opacity-40"}`}>{i + 1}</div>
                            <Avatar url={u.avatar_url} name={u.name} size={40} />
                            <div className="flex-1 min-w-0">
                                <div className="font-display text-lg truncate">{u.name}</div>
                                {u.bio ? <div className="text-xs opacity-60 truncate">{u.bio}</div> : null}
                            </div>
                            <div className="text-right">
                                <div className="font-display text-xl text-[var(--ok-accent)] tabular-nums">{u.reputation}</div>
                                <div className="text-[10px] uppercase tracking-widest opacity-50 font-mono">reputation</div>
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
